import { generateApi } from 'utils/api'

const {
  createDashboardItemDashboardItemMetric: createDashboardItemMetric,
  deleteDashboardItemMetric
} = generateApi('dashboardItemMetric', ['dashboardItem'])

export { createDashboardItemMetric, deleteDashboardItemMetric }
